import api from '@app/api'

import type { Report } from '@app/entities/report'

const BASE_URL = '/reports/'

const createUrl = (...args: string[]): string => {
  if (args.length === 0) return BASE_URL

  return BASE_URL + args.join('/') + '/'
}

export const getReport = async (id: string | number): Promise<Report> => {
  const url = createUrl(String(id))

  const response = await api.get<Report>(url)

  return response.data
}
